import { render } from "./NavFooter.vue?vue&type=template&id=471cc738&scoped=true"
import script from "./NavFooter.vue?vue&type=script&lang=js"
export * from "./NavFooter.vue?vue&type=script&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=471cc738&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/Danmarksfugle2.0-frontend/code-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471cc738"]])

export default __exports__